import { HintAnimation } from '../hint-motion';
import { bubble, hline, text } from '../../academy/films/story-scene';
import { abs, C, glass, icon, orbiTemplate } from './scene-kit';
import { glowLayer, HintStory, inputField, portalShell } from './hint-story';

/**
 * Hinweis A „Frag Orbi, deinen Portal-Assistenten“.
 *
 * Didaktik: Die Hemmschwelle ist „Wo fange ich an?“ — der Film zeigt eine
 * echte Einsteigerfrage statt eines Funktionskatalogs. WARUM „Fragen zum
 * Portal? Orbi zeigt dir den Weg“ → WO Orbi-Knopf oben rechts (mit ⌘K als
 * Abkürzung eingeblendet) → WAS Frage tippen, Orbi antwortet → GESCHAFFT
 * Orbi lässt die Stelle im Menü aufleuchten (er zeigt, statt nur zu
 * erklären) und lacht.
 */

const PANEL = { x: 392, y: 56, w: 238, h: 284 };
const ORBI_BTN: [number, number] = [525, 29];
const SEND: [number, number] = [PANEL.x + 210, PANEL.y + 254];

const tiles = ['Statistik-Tutor', 'Mathe-Tutor', 'Support']
  .map((name, i) =>
    glass(
      18,
      0.5,
      `left:${20 + i * 140}px;top:64px;width:128px;height:96px;`,
      `<div style="${abs(46, 12, 36, 36)}">${orbiTemplate(`tile${i}`, 36)}</div>` +
        text(8, 60, 112, name, 12, 600, C.text, 'text-align:center;'),
    ),
  )
  .join('');

const content = text(20, 12, 300, 'KI-Agenten', 18, 400) + hline(16, 46, 428) + tiles;

const kbd =
  `<div data-r="kbd" style="${abs(494, 50, 62, 22, 'opacity:0;border-radius:7px;background:#243650;color:#fff;font-size:11px;font-weight:600;display:flex;align-items:center;justify-content:center;gap:4px;box-shadow:0 6px 12px -6px rgb(20 38 70 / .5);')}">⌘ K</div>`;

const panel =
  `<div data-r="panel" style="opacity:0;">` +
  glass(
    22,
    0.92,
    `left:${PANEL.x}px;top:${PANEL.y}px;width:${PANEL.w}px;height:${PANEL.h}px;`,
    `<div style="${abs(14, 11, 24, 24)}">${orbiTemplate('pan', 24)}</div>` +
      text(46, 12, 170, 'Portal-Assistent', 13, 600) +
      hline(12, 44, 214) +
      bubble(14, 58, 196, 'Hallo! Wobei kann ich helfen?', false) +
      `<div data-r="q" style="opacity:0;">${bubble(64, 104, 160, 'Wo verbinde ich Moodle?', true)}</div>` +
      `<div data-r="a" style="opacity:0;">${bubble(14, 150, 204, 'Unter <b>Integrationen</b> — ich zeig dir die Stelle.', false)}</div>` +
      inputField(12, 238, 180, 'Frag mich etwas …', 'ph', 'typed') +
      `<div style="${abs(198, 242, 26, 26, `border-radius:999px;background:${C.action};display:flex;align-items:center;justify-content:center;`)}">${icon('send', 14, '#fff', 2)}</div>`,
  ) +
  `</div>`;

export const meetOrbiAnimation = (): HintAnimation =>
  new HintStory({
    intro: { line1: ['Fragen', 'zum', 'Portal?'], line2: ['Orbi', 'zeigt', 'dir', 'den', 'Weg'] },
    portal:
      portalShell({ active: 0, orbiButton: true, content }) +
      glowLayer('orbiGlow', 510, 14, 30, 30) +
      kbd +
      panel,
    tracks: [
      { r: 'kbd', at: [1.3, 1.42, 2.05, 2.2], o: [0, 1, 1, 0], y: [4, 0, 0, 0] },
      { r: 'panel', at: [1.6, 1.85], o: [0, 1], x: [36, 0] },
      { r: 'ph', at: [1.93, 1.96, 2.68, 2.74], o: [1, 0, 0, 1] },
      { r: 'typed', at: [2.66, 2.7], o: [1, 0] },
      { r: 'q', at: [2.68, 2.84], o: [0, 1], y: [6, 0] },
      { r: 'a', at: [2.98, 3.16], o: [0, 1], y: [6, 0] },
    ],
    typing: [{ r: 'typed', text: 'Wo verbinde ich Moodle?', from: 1.98, to: 2.5 }],
    glows: [
      { r: 'orbiGlow', at: 1.25, dur: 0.45 },
      { r: 'navGlow3', at: 3.55, dur: 0.85 },
    ],
    orbis: [
      { prefix: 'pan', pop: 2.98, laugh: 3.1 },
    ],
    cursor: {
      at: [0, 1.1, 1.49, 1.62, 2.52, 2.82, 99],
      x: [300, 300, ORBI_BTN[0], ORBI_BTN[0], SEND[0], 470, 470],
      y: [250, 250, ORBI_BTN[1] + 2, ORBI_BTN[1] + 2, SEND[1], 326, 326],
      clicks: [1.55, 2.6],
    },
    camera: {
      at: [0, 1.88, 2.12, 3.38, 3.6, 99],
      x: [320, 320, 384, 384, 320, 320],
      y: [176, 176, 198, 198, 176, 176],
      s: [1, 1, 1.25, 1.25, 1, 1],
    },
    still: 3.95,
  });

